import * as t from "react";
var r = globalThis?.document ? t.useLayoutEffect : () => {
}, s = t[" useId ".trim().toString()] || (() => {
}), c = 0;
function n(e) {
  const [u, a] = t.useState(s());
  return r(() => {
    a((o) => o ?? String(c++));
  }, [e]), e || (u ? `radix-${u}` : "");
}
export {
  n as u
};
//# sourceMappingURL=index.BUG7NYeV.js.map
